import React from 'react';
import { node } from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useBreakpoint } from '@one-thd/sui-atomic-components';

export const IFrameManager = ({ children = null }) => {
  const { lesser: isMobile } = useBreakpoint('lg');
  const maaQueryParams = useConfigService('maaqueryparams') || '';
  const assistantDomain = useConfigService('magic-apron-assistant-domain') || 'https://www.homedepot.com';
  const envDomain = import.meta.env?.MAA_DOMAIN;
  const iframeSrc = (envDomain || assistantDomain) + import.meta.env.MAA_IFRAME_PATH + maaQueryParams;

  return (
    <>
      {children}
      <iframe
        title="Magic Apron Assistant"
        className="sui-flex-grow sui-border-none sui-min-h-0"
        src={iframeSrc}
        loading={isMobile ? 'eager' : 'lazy'}
      />
    </>
  );
};

IFrameManager.propTypes = {
  children: node
};

IFrameManager.defaultProps = {
  children: null
};